






































import ApiClient from '@/common/api'
import BlueButton from '@/views/atoms/BlueButton.vue'
import TextBox from '@/views/atoms/TextBox.vue'
import SelectBox from '@/views/atoms/SelectBox.vue'
import Global from '@/common/global.js'
import ErrorLabel from '@/views/atoms/ErrorLabel.vue'
import BackButton from '@/views/atoms/BackButton.vue'
import store from '@/store'
import PopupChangePassowrd from '@/views/template/PopupChangePassowrd.vue'

export default
  components: {
    ApiClient
    BlueButton
    TextBox
    SelectBox
    Global
    ErrorLabel
    BackButton
    PopupChangePassowrd
  }

  data: () ->
    level: Global.level()
    defaultLevel: '0'
    defaultCustomerId: '2'
    paramsId: false
    customerList: store.getters.customerList,
    customer: [],
    showChangePassword: false
    id: ''


  created: () ->
    if @.$route.params.id > 0
      @paramsId = true
      api = new ApiClient()
      data = await api.get('/fc/customer/detail/' + @.$route.params.id)
      @defaultLevel = data.detail.level
      @defaultCustomerId = data.detail.customer_id
      store.dispatch('setDetailParam', data)
    for row, index in await @customerList
      @customer.push(
        id: row.id
        name: row.name
      )

  methods: {
    save_click: () ->
      api = new ApiClient()
      data = await api.post('/fc/customer/save')
      if data.errors.length == 0
        @$router.push '/customer'
    back: () ->
      @$router.push '/customer'
    edit_click: () ->
      api = new ApiClient()
      data = await api.post('/fc/customer/save')
      if data.errors.length == 0
        @$router.push '/customer'
    close: () ->
      @showChangePassword = false
    showPopup: (id) ->
      @id = @.$route.params.id
      @showChangePassword = true
  }
